/* istanbul ignore file */
import React from 'react';
import { Link } from 'react-router-dom';
import { useVacancyPublicationUrl } from 'domain/recruiting/vacancy/publication/vacancyPublicationRoute';

const VacancyPublicationLink = ({ id, name }: { id: StringOrNumber; name: string }) => {
  const { getSingleEntityUrl } = useVacancyPublicationUrl();

  return <Link to={getSingleEntityUrl(id)}>{name}</Link>;
};

export default VacancyPublicationLink;
